import { FC, useEffect } from "react";
import {
  CheckAuthentication,
  HideBrokenImage,
  OpenImageInNewWindow,
  UpdateUserLastActionDate,
} from "../../../helper/ui/methods";
import { useNavigate } from "react-router-dom";
import { useAppStateContext } from "../../../middleware/context/state-context-provider";
import MainNavigationPanel from "../../ui/user/main-navigation-panel";
import MainFooterPanel from "../../ui/user/main-footer-panel";

export const Charsync: FC = () => {
  const [state, dispatch] = useAppStateContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.user === null || state.user === undefined) {
      CheckAuthentication(dispatch);
    }
  }, []);

  return (
    <>
      {(() => {
        return (
          <div
            id="pageWrapper"
            onClick={
              state.user
                ? () => UpdateUserLastActionDate(state.user!, dispatch)
                : undefined
            }
          >
            <MainNavigationPanel user={state.user} />
            <div id="contentWrapper">
              <div id="content" className="pageSurface">
                <div id="informationCanvas">
                  <div className="pageCrumbs">
                    <span
                      onClick={() => {
                        navigate("/products");
                      }}
                    >
                      PRODUCTS
                    </span>
                    <span>/</span>
                    <span className="crumbCurrent">CHARSYNC</span>
                  </div>
                  <h1>Charsync</h1>
                  <p>
                    Charsync is part of ForgeLine, our Autodesk® Navisworks®
                    plugin. It keeps the models appended to your federation file synchronized with
                    the latest versions stored in your Digital Charcoal cloud
                    projects, eliminating the manual chore of tracking down,
                    re-downloading, and re-appending updated source files.
                  </p>
                  <p>
                    First, Charsync lets you link each model appended to a
                    Navisworks federation file (.nwf) directly to its
                    corresponding file in a Digital Charcoal project. The link —
                    including the project, the source file, and the exact
                    version currently in use — is recorded in a registry
                    embedded within the document itself, so the mapping travels
                    with the file and survives across sessions and machines.
                  </p>
                  <p>
                    Second, the plugin detects when a newer version of a linked
                    file becomes available in the cloud and downloads it to a
                    local folder of your choosing. It then updates the
                    Navisworks scene in place, so your federated model always
                    reflects the most current design data without any manual
                    re-appending.
                  </p>
                  <p>
                    Third, Charsync supports the full range of formats
                    Navisworks can append — including IFC, DWG, DXF, DGN, RVT,
                    NWC, NWD, and more — and performs every model operation
                    safely on the Navisworks main thread to protect the
                    integrity of your document during synchronization.
                  </p>
                  <p>
                    Finally, a dedicated project settings window gives you a
                    clear overview of every linked model, its current and
                    available versions, and its local file location, putting the
                    state of your entire federation at your fingertips.
                  </p>
                  <p>
                    For detailed instructions on how to utilize Charsync
                    effectively, please consult the accompanying
                    <a
                      className="anchor"
                      href="https://digitalcharcoal.io/pdf/instructions/charsync/Charsync_Instruction.pdf"
                    >
                      {" "}
                      documentation
                    </a>
                    .
                  </p>
                  <div className="contentImageWrapper">
                    <img
                      src="assets/images/charsync/charsync_1.png"
                      alt="Charsync"
                      onClick={() =>
                        OpenImageInNewWindow("assets/images/charsync/charsync_1.png")
                      }
                      onError={HideBrokenImage}
                    />
                    <img
                      src="assets/images/charsync/charsync_2.png"
                      alt="Charsync"
                      onClick={() =>
                        OpenImageInNewWindow("assets/images/charsync/charsync_2.png")
                      }
                      onError={HideBrokenImage}
                    />
                    <img
                      src="assets/images/charsync/charsync_3.png"
                      alt="Charsync"
                      onClick={() =>
                        OpenImageInNewWindow("assets/images/charsync/charsync_3.png")
                      }
                      onError={HideBrokenImage}
                    />
                  </div>
                </div>
              </div>
            </div>
            <MainFooterPanel />
          </div>
        );
      })()}
    </>
  );
};
